import { HttpRequest } from "../utils";

const httpRequest = new HttpRequest();

export const LateFeeApi = {
  getConfig: async () => {
    return httpRequest.get("/inv/late-fee-config");
  },
  updateConfig: async (data: any) => {
    return httpRequest.put("/inv/late-fee-config", data);
  },
  getOverrides: async (params?: any) => {
    return httpRequest.get("/inv/late-fee-config/overrides", params);
  },
  updateOverride: async (buyerBusinessId: string, data: any) => {
    return httpRequest.put(`/inv/late-fee-config/overrides/${buyerBusinessId}`, data);
  },
  getInvoiceLateFees: async (invoiceId: string) => {
    return httpRequest.get(`/inv/invoice/${invoiceId}/late-fees`);
  },
};
